import { render, staticRenderFns } from "./detailTable.vue?vue&type=template&id=f1f2d1a2&scoped=true&"
import script from "./detailTable.vue?vue&type=script&lang=js&"
export * from "./detailTable.vue?vue&type=script&lang=js&"
import style0 from "./detailTable.vue?vue&type=style&index=0&id=f1f2d1a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f2d1a2",
  null
  
)

export default component.exports